function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import { usePrefixCls } from '@byte-design/config';
import { Attention } from '../../common/icons';
import { Popover } from '../popover';
export var ErrorBoundary = function (_React$Component) {
  _inherits(ErrorBoundary, _React$Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary() {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.apply(this, arguments);
    _this.state = {
      error: null,
      info: null,
      showSingleton: false
    };
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate() {
      return true;
    }
  }, {
    key: "componentDidCatch",
    value: function componentDidCatch(error, stack) {
      var onError = this.props.onError;
      var info = stack.componentStack || '';
      onError && onError(error, info);
      this.setState({
        error: error,
        info: info
      });
    }
  }, {
    key: "renderDefault",
    value: function renderDefault(error, info) {
      var _this2 = this;

      var showSingleton = this.state.showSingleton;
      var className = usePrefixCls('error-boundary');
      var classNamePopper = usePrefixCls('error-boundary-popper');
      var classNameInfo = usePrefixCls('error-boundary-info');
      return React.createElement("div", {
        className: className
      }, React.createElement(Popover.Singleton, {
        arrow: true,
        lazyInit: true,
        show: showSingleton,
        placement: "top",
        getPopper: function getPopper(data) {
          return React.createElement("div", {
            className: classNamePopper
          }, data);
        },
        onShow: function onShow() {
          return _this2.setState({
            showSingleton: true
          });
        },
        onHide: function onHide() {
          return _this2.setState({
            showSingleton: false
          });
        },
        popoverClassName: "popover-demo-popover"
      }, React.createElement(Popover.HoverTrigger, {
        data: info,
        showDelay: 200,
        hideDelay: 200,
        style: {
          marginLeft: '10px'
        }
      }, React.createElement(Attention, {
        theme: "filled",
        fill: "#F45858",
        style: {
          cursor: 'pointer'
        }
      }))), React.createElement("span", {
        className: classNameInfo
      }, error.toString()));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          error = _this$state.error,
          info = _this$state.info;
      var _this$props = this.props,
          children = _this$props.children,
          FallbackComponent = _this$props.FallbackComponent;

      if (error !== null) {
        return FallbackComponent ? React.createElement(FallbackComponent, {
          error: error,
          info: info || ''
        }) : this.renderDefault(error, info || '');
      }

      return children;
    }
  }]);

  return ErrorBoundary;
}(React.Component);